var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDev)?_c('BaseLanding',{attrs:{"filter":_vm.filter,"faq-id":11}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }